<template>
  <nav class="navbar fixed-top main-navbar navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" href="/">
      <svgHelper name="logo"></svgHelper>
    </a>

    <div class="navbar-header">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav d-flex align-items-center">
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'home' }"
            ><!-- <i class="fas fa-home fa-lg"></i> -->Home</router-link
          >
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'search-jobs' }">Search Jobs</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'job-posting' }">Free job posting</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'tech-recruiting' }"
            >TECH RECRUITING</router-link
          >
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'freelancers' }"
            >FIND FREELANCERS
          </router-link>
        </li>
        <!--
        <li class="nav-item">
          <router-link class="nav-link" to="/about-us">ABOUT US</router-link>
        </li> -->
        <li class="nav-item ml-auto">
          <button id="login-btn" class="btn btn-secondary" @click="openModal">Log In</button>
        </li>
        <li class="nav-item">
          <button id="register-btn" class="btn btn-primary" @click="openModal">
            SIGN UP
          </button>
        </li>
        <!-- LOGIN -->
        <!-- <li class="nav-item ml-auto" v-if="isLoggedIn">
          <button @click="onLogout" class="btn btn-primary mr-2">Sign Out</button>
          <button @click="onGoToMyProfile" class="btn btn-secondary">My Profile</button>
        </li> -->
      </ul>
    </div>
    <CustomMainModal v-show="showModal" @close="closeModal">
      <template v-slot:header>
        <h5>{{ modalTitle }}</h5>
      </template>
      <Signin
        v-if="showLogin"
        @go-to-register="openModal"
        @go-to-reset-password="openModal"
        @go-to-register-employer="openEmployer"
      ></Signin>
      <div v-if="showModal">
        <Register
          v-show="showRegister && showModal"
          @go-to-login="openModal"
          @close="showModal = false"
          @set-email="email => (currentEmail = email)"
          @open-employer-register="openEmployer"
          @emailVerification="
            (openEmailVerification = true), (showRegister = false), (modalTitle = 'Verification')
          "
        />
      </div>

      <ResetPassword v-if="showResetPassword" @close="showModal = false" />
      <VerificationCode
        v-if="openEmailVerification"
        @prevStep="prevStep"
        :currentEmail="currentEmail.email"
      />
      <RegisterEmployer
        v-if="showRegisterEmployer && showModal"
        @open-candidate-register="openCandidate"
      />
    </CustomMainModal>
  </nav>
</template>

<script>
import CustomMainModal from '@/components/Modals/CustomMainModal';
import Signin from '@/components/Signin/Signin';
import Register from '@/components/Register/Register';
import RegisterEmployer from '@/components/Register/RegisterEmployer';
import ResetPassword from '@/components/ResetPassword/ResetPassword';
import VerificationCode from '@/components/SearchJob/VerificationCode';
import VerificationCodeEmployer from '../../views/PublicPagesBase/VerificationCodeEmployer';
import { mapGetters } from 'vuex';

export default {
  components: {
    Register,
    RegisterEmployer,
    Signin,
    CustomMainModal,
    ResetPassword,
    VerificationCode,
    VerificationCodeEmployer,
  },
  props: {
    showForm: Object,
    jobId: String,
  },

  watch: {
    showForm: {
      handler(newVal, oldVal) {
        console.log(newVal.formType);
        if (newVal.formType === 'candidate') {
          this.openCandidate();
        }
        if (newVal.formType === 'employer') {
          this.openEmployer();
        }
        if (newVal.formType === 'login') {
          this.openSignIn();
        }
      },
      deep: true,
    },
    jobId: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.id = newVal;
        }
      },
    },
  },
  data: () => ({
    modalTitle: '',
    showModal: false,
    showResetPassword: false,
    showLogin: false,
    showRegister: false,
    showRegisterEmployer: false,
    openEmailVerification: false,
    currentEmail: '',
    id: '',
  }),
  methods: {
    openCandidate() {
      this.showModal = true;
      this.modalTitle = 'Sign Up as Candidate';
      this.showLogin = false;
      this.showResetPassword = false;
      this.showRegister = true;
      this.showRegisterEmployer = false;
      this.showLogin = false;
    },
    openEmployer() {
      this.showModal = true;
      this.showRegister = false;
      this.showRegisterEmployer = true;
      this.modalTitle = 'Sign Up as Employer';
      this.showLogin = false;
      this.showResetPassword = false;
    },
    openSignIn() {
      this.showModal = true;
      this.modalTitle = 'Log In';
      this.showLogin = true;
      this.showRegister = false;
      this.showRegisterEmployer = false;
      this.showResetPassword = false;
    },
    closeModal() {
      this.showModal = false;
      this.showRegister = false;
      this.openEmailVerification = false;
      this.showRegisterEmployer = false;
      this.modalTitle = '';
    },
    prevStep() {
      this.showRegister = true;
      this.openEmailVerification = false;
      this.modalTitle = 'Sign Up as Candidate';
    },
    onLogout() {
      this.$router.push({ name: 'logout' });
    },
    /* onGoToMyProfile() {
      this.$router.push({ name: 'user-profile' });
    }, */
    openModal(e) {
      if (this.getAccType == 'admin') {
        this.$router.push({ name: `admin-jobs` });
      }

      if (this.getAccType == 'recruiter') {
        this.$router.push({ name: `recruiter-jobs` });
      }

      if (this.getAccType == 'manager') {
        this.$router.push({ name: `manager-profile` });
      }

      /*  if (this.getAccType == 'user') {
        this.$router.push({ name: `user-jobs` });
      } */

      if (this.getAccType == 'candidate') {
        this.$router.push({ name: `user-profile` });
      }

      this.showModal = true;

      if (e.target.id == 'login-btn') {
        this.modalTitle = 'Log In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'register-btn') {
        if (
          this.$route.name === 'job-posting' ||
          this.$route.name === 'recruiting-services' ||
          this.$route.name === 'freelancers' ||
          this.$route.name === 'tech-recruitment' ||
          this.$route.name === 'new-jobshark' ||
          this.$route.name === 'tech-recruiting'
        ) {
          this.showModal = true;
          this.showRegister = false;
          this.showRegisterEmployer = true;
          this.modalTitle = 'Sign Up as Employer';
          this.showLogin = false;
          this.showResetPassword = false;
        } else {
          this.modalTitle = 'Sign Up as Candidate';
          this.showLogin = false;
          this.showResetPassword = false;
          this.showRegister = true;
          this.showResetPassword = false;
        }
      } else if (e.target.id == 'register-link') {
        this.modalTitle = 'Sign Up as Candidate';
        this.showRegister = true;
        this.showLogin = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'forgotten-password') {
        this.modalTitle = 'Reset Password';
        this.showRegister = false;
        this.showLogin = false;
        this.showResetPassword = true;
      } else if (e.target.id == 'already-have-account') {
        this.modalTitle = 'Log In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      }
    },
  },
  computed: {
    ...mapGetters(['getAccType', 'isLoggedIn']),
  },
  mounted() {
    console.log(this.$route.name);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.router-link-exact-active {
  background: $color-orange;
}

.navbar {
  padding: 0 30px !important;
  width: 100%;
  &.fixed-top {
    position: fixed !important;
  }

  .navbar-brand {
    .svg-icon {
      width: 60px;
      height: 60px;
      margin-left: 10px;
      margin-right: 60px;
    }
  }
  .navbar-nav {
    height: 70px;
    width: 100%;

    li {
      height: 100%;
      display: flex;
      align-items: center;

      a {
        display: flex;
        align-items: center;
        height: 100%;
        text-transform: uppercase;
        font-size: 15px;
        /* &.active,
        &:hover {
          background: $color-orange;
        } */
      }

      .btn {
        text-transform: uppercase;
        font-size: 15px;
      }

      #register-btn {
        margin-left: 12px;
      }

      &:first-of-type {
        margin-right: 18px;
      }

      &:nth-of-type(2) {
        margin-right: 18px;
      }
    }
  }
}
#register-btn-mobile,
#login-btn-mobile {
  display: none;
}

@media only screen and (max-width: 992px) {
  .navbar {
    padding: 0 12px !important;
    .navbar-toggler {
      position: relative;
    }
    .navbar-nav {
      height: auto;
      li {
        width: 100%;
        margin: 6px 0 !important;
        a {
          display: block;
          width: 100%;
          padding-left: 12px;
        }
        .btn {
          margin-left: 12px;
        }
        #register-btn {
          margin: 0 0 0 12px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .navbar-nav {
    li {
      .btn {
        width: 100%;
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .navbar {
    .navbar-brand {
      .svg-icon {
        width: 50px;
        height: 50px;
      }
    }
  }
  .navbar-nav {
    li {
      .btn {
        width: 100%;
      }
    }
  }
}
</style>
